import { useQuery } from "@tanstack/react-query";
import { PublicLayout } from "@/components/PublicLayout";
import { Markdown } from "@/components/Markdown";
import api from "@/lib/api";

export default function Legal({ page }) {
  const { data } = useQuery({ queryKey: ["content", page], queryFn: async () => (await api.get(`/content/${page}`)).data });
  return (
    <PublicLayout>
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        <h1 data-testid="legal-title" className="text-3xl font-extrabold text-[#263871] sm:text-4xl">{data?.title || "…"}</h1>
        <div className="mt-8"><Markdown text={data?.body || ""} /></div>
        {data?.updated_at && <p className="mt-12 text-xs text-slate-400">Dernière mise à jour : {new Date(data.updated_at).toLocaleDateString("fr-FR")}</p>}
      </section>
    </PublicLayout>
  );
}
